<template>
    
<app-wrapper class="pagination" v-if="pages > 1">

    <div class="pagination-item" v-for="index in pages" :key="index" :class="{'is-active': index === current}" v-on:click="$emit('change', index)">{{ index }}</div>

</app-wrapper>

</template>

<script>

export default {

    props: ['pages', 'current']
    
}

</script>

<style scoped>

.pagination {
    display: flex;
    justify-content: center;
    flex-direction: row;
}

.is-mobile .pagination {
    margin-bottom: 20px;
}

.pagination-item {
    width: 40px;
    height: 40px;
    border: 1px solid var(--color-grey-light);
    line-height: 38px;
    text-align: center;
    font-size: 16px;
    border-radius: 4px;
	margin: 0px 2px;
    cursor: pointer;
    color: var(--color-grey);
}

.is-desktop .pagination-item:hover {
    border-color: var(--color-grey-highlight);
    color: var(--color-grey);
}

.pagination-item.is-active,
.is-desktop .pagination-item.is-active:hover {
    color: #fff;
    border-color: var(--color-blue-light);
    background-color: var(--color-blue-light);
}

</style>